import ModalBasicLayout from "../../../Modal/ModalBasicLayout";
import GenerateCampaignFormLinkedin from "./GenerateCampaignFormLinkedin";

const GenerateCampaignLinkedin = ({
  initialData = {},
  modalOpen,
  onCloseModal,
  campaignID,
  generatedPlatforms = {},
  context,
  onCallbackSave = () => {},
  verifyBlockAlert = true,
}) => {
  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={async () => {
        onCloseModal();
      }}
      fullWidth={true}
      maxWidth="md"
      scroll="paper"
      sxPaper={{
        maxWidth: 750,
      }}
    >
      <GenerateCampaignFormLinkedin
        initialData={initialData}
        campaignID={campaignID}
        generatedPlatforms={generatedPlatforms}
        context={context}
        onCallbackSave={onCallbackSave}
        verifyBlockAlert={verifyBlockAlert}
      />
    </ModalBasicLayout>
  );
};

export default GenerateCampaignLinkedin;
